"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var VSteps_1 = require("../VSteps");
var SDiv = (0, styled_components_1.default)('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-family: arial;\n  -ms-transform: scaleX(-1) rotate(-45deg); /* IE 9 */\n  -webkit-transform: scaleX(-1) rotate(-45deg); /* Chrome, Safari, Opera */\n  transform: scaleX(-1) rotate(-45deg);\n"], ["\n  color: ", ";\n  font-family: arial;\n  -ms-transform: scaleX(-1) rotate(-45deg); /* IE 9 */\n  -webkit-transform: scaleX(-1) rotate(-45deg); /* Chrome, Safari, Opera */\n  transform: scaleX(-1) rotate(-45deg);\n"])), function (props) { var _a; return (_a = props.mainColor) !== null && _a !== void 0 ? _a : '#137cbd'; });
var CheckMark = function () {
    var mainCtx = (0, react_1.useContext)(VSteps_1.MainStepsContext);
    return react_1.default.createElement(SDiv, { mainColor: mainCtx.mainColor }, 'L');
};
exports.default = CheckMark;
var templateObject_1;
